<template xmlns="http://www.w3.org/1999/html">
  <div>
    <vs-dropdown vs-custom-content vs-trigger-click color="#3089f0">
      <div class="label-container">
        {{ label }}
        <vs-icon icon="expand_more"></vs-icon>
      </div>
      <vs-dropdown-menu style="width: 180px; z-index: 20">
        <!-- Expanded Multilevel Dropdown-->
        <template v-if="layout === 'expanded'">
          <template v-for="(groupItem, index) in groupList">
            <div :key="index">
              <span class="group-item-label">{{ groupItem.label }}</span>
              <vs-dropdown-item
                v-for="(option, idx) in groupItem.options"
                :key="idx"
              >
                <vs-checkbox
                  color="#3089f0"
                  :value="value"
                  @input="$emit('input', $event)"
                  :vs-value="option.value"
                >
                  {{ option.label }}</vs-checkbox
                >
              </vs-dropdown-item>
              <vs-divider
                class="mt-2 mb-2"
                v-if="index !== groupList.length - 1"
              />
            </div>
          </template>
        </template>
        <!-- Collapse Multilevel Dropdown -->
        <template v-else-if="layout === 'collapse'">
          <vs-collapse class="-m-3">
            <template v-for="(groupItem, index) in groupList">
              <vs-collapse-item :key="index">
                <div slot="header">
                  <span class="group-item-label">{{ groupItem.label }}</span>
                </div>
                <ul class="group-options">
                  <template v-for="(option, idx) in groupItem.options">
                    <li @click.stop :key="idx">
                      <vs-checkbox
                        color="#3089f0"
                        :value="value"
                        @input="$emit('input', $event)"
                        :vs-value="option.value"
                      >
                        {{ option.label }}</vs-checkbox
                      >
                    </li>
                  </template>
                </ul>
              </vs-collapse-item>
            </template>
          </vs-collapse>
        </template>
        <!-- CheckBox Dropdown -->
        <template v-else>
          <template v-for="(option, idx) in options">
            <vs-dropdown-item @click="selectOption(idx)" :key="idx">
              <vs-checkbox
                color="#3089f0"
                :value="value"
                @input="$emit('input', $event)"
                :vs-value="{field, value:option.value}"
                :id="`option-${idx}`"
              >
                {{ option.label }}
              </vs-checkbox>
            </vs-dropdown-item>
          </template>
        </template>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>
<script>
export default {
  name: "CheckboxDropdown",
  props: {
    label: {
      type: String,
      required: false,
    },
    field: {
      type: String,
      required: false,
    },
    groupList: {
      type: Array,
    },
    layout: {
      type: String,
      default: "None",
    },
    options: {
      type: Array,
    },
    value: {
      type: Array,
    },
  },
  data() {
    return {
      selected:[],
      roles:[]
    };
  },
  computed: {
    fieldName() {
      const temp = this.label.split(" ");
      return temp.length > 1
        ? temp[0].toLowerCase() + temp[1]
        : temp[0].toLowerCase();
    },
  },
  methods: {
    selectOption(idx) {

      document.getElementById(`option-${idx}`).click();
    },
    selectUsers(id){
      //in here you can check what ever condition  before append to array.
      // console.log(id);
      // if(this.selected.includes(id)){
      //   this.selected=_.without(this.selected,id)
      // }else{
      //   this.selected.push(id)
      // }
    }
  }
};
</script>
<style scoped>
.label-container {
  border: 1px solid #ccc8c8;
  display: flex;
  align-items: center;
  padding: 8px 15px;
  color: grey;
  border-radius: 5px;
  cursor: pointer !important;
}
button {
  cursor: pointer !important;
}
.group-item-label {
  padding: 2px;
  color: #231d4f;
  font-weight: 500;
  font-size: 1rem;
}
.group-options {
  margin-top: -1rem;
}
.group-options li {
  padding: 0.5rem 0;
  color: #848199;
}
</style>
